import ai from './ai';
import billing from './billing';
import certification from './certification';
import commerce from './commerce';
import dashboard from './dashboard';
import definitions from './definitions';
import education from './education';
import growth from './growth';
import hr from './hr';
import identity from './identity';
import knowledge from './knowledge';
import notifications from './notifications';
import operations from './operations';
import settings from './settings';
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS ||============================== //
// ZERCODE CHANGE: Berry's sample menu groups (sample-page/pages/other pointed at
// removed demo routes) replaced with the admin app's real menu.

const menuItems: { items: NavItemType[] } = {
  items: [dashboard, education, certification, growth, commerce, billing, hr, operations, knowledge, ai, notifications, identity, definitions, settings]
};

export default menuItems;
